module.exports = __webpack_public_path__ + "img/stamp.7511015a.png";